import React from 'react';
import '../../styles/facilities/main.css';

const Main = () => {
    return (
        <div id='facilitiesMain'>
            <div className="facilities">
                <div className="container main-box">
                    <div className="back">
                        <h1 className="my-heading">Campus Facilities</h1>
                        <div className="boxes">
                            <div className="box">
                                <img src="assets/images/facilities/auditorium-2.jpg" alt="" />
                                <div className="content">
                                    <h1>Auditorium</h1>
                                    <p>
                                        The university has an auditorium with a capacity of more than a
                                        1000 seats. The auditorium is well equipped with light and sound
                                        systems for cultural functions, etc.
                                    </p>
                                    <div className="text-center pt-2 pb-2">
                                        <button
                                            type="button"
                                            className="btn btn-facility"
                                            data-bs-toggle="modal"
                                            data-bs-target="#exampleModal"
                                            style={{ justifyContent: "center" }}
                                        >
                                            Read More
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="modal fade"
                                id="exampleModal"
                                tabIndex={-1}
                                aria-labelledby="exampleModalLabel"
                                aria-hidden="true"
                            >
                                <div className="modal-dialog modal-lg">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="exampleModalLabel">
                                                Auditorium
                                            </h5>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                data-bs-dismiss="modal"
                                                aria-label="Close"
                                            />
                                        </div>
                                        <div className="modal-body">
                                            <div
                                                id="carouselExampleIndicators"
                                                className="carousel slide"
                                                data-bs-ride="carousel"
                                            >
                                                <div className="carousel-inner">
                                                    <div className="carousel-item active">
                                                        <img
                                                            src="assets/images/facilities/auditorium.jpg"
                                                            className="d-block w-100"
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="carousel-item">
                                                        <img
                                                            src="assets/images/facilities/auditorium-2.jpg"
                                                            className="d-block w-100"
                                                            alt=""
                                                        />
                                                    </div>
                                                </div>
                                                <button
                                                    className="carousel-control-prev"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="prev"
                                                >
                                                    <span
                                                        className="carousel-control-prev-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Previous</span>
                                                </button>
                                                <button
                                                    className="carousel-control-next"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="next"
                                                    style={{ color: "black" }}
                                                >
                                                    <span
                                                        className="carousel-control-next-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Next</span>
                                                </button>
                                            </div>
                                            <p className="mt-3">
                                                The university has an auditorium with a capacity of more than
                                                a 1000 seats. The auditorium is well equipped with light and
                                                sound systems for cultural functions, etc.
                                            </p>
                                        </div>
                                        <div className="modal-footer">
                                            <button
                                                type="button"
                                                className="btn btn-secondary"
                                                data-bs-dismiss="modal"
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="box" id="bank">
                                <img src="assets/images/facilities/bank-ccs.jpg" alt="" />
                                <div className="content">
                                    <h1>Bank facility</h1>
                                    <p>
                                        Separate branch of Allahabad bank is available to the students in
                                        the University Campus, which provides all facilities to the
                                        students for submitting their fee &amp; other banking services.
                                    </p>
                                    <div className="text-center pt-2 pb-2">
                                        <button
                                            type="button"
                                            className="btn btn-facility"
                                            data-bs-toggle="modal"
                                            data-bs-target="#exampleModal1"
                                            style={{ justifyContent: "center" }}
                                        >
                                            Read More
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="modal fade"
                                id="exampleModal1"
                                tabIndex={-1}
                                aria-labelledby="exampleModalLabel"
                                aria-hidden="true"
                            >
                                <div className="modal-dialog modal-lg">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="exampleModalLabel">
                                                Bank facility
                                            </h5>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                data-bs-dismiss="modal"
                                                aria-label="Close"
                                            />
                                        </div>
                                        <div className="modal-body">
                                            <div
                                                id="carouselExampleIndicators"
                                                className="carousel slide"
                                                data-bs-ride="carousel"
                                            >
                                                <div className="carousel-inner">
                                                    <div className="carousel-item active">
                                                        <img
                                                            src="assets\images\facilities\bank-ccs.jpg"
                                                            className="d-block w-100"
                                                            alt=""
                                                        />
                                                    </div>
                                                </div>
                                                <button
                                                    className="carousel-control-prev"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="prev"
                                                >
                                                    <span
                                                        className="carousel-control-prev-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Previous</span>
                                                </button>
                                                <button
                                                    className="carousel-control-next"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="next"
                                                    style={{ color: "black" }}
                                                >
                                                    <span
                                                        className="carousel-control-next-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Next</span>
                                                </button>
                                            </div>
                                            <p className="mt-3">
                                                A separate branch of Allahabad bank is available to the
                                                students in the University Campus, which provides all
                                                facilities to the students for submitting their fee &amp;
                                                other banking services.
                                            </p>
                                        </div>
                                        <div className="modal-footer">
                                            <button
                                                type="button"
                                                className="btn btn-secondary"
                                                data-bs-dismiss="modal"
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="box" id="canteen">
                                <img src="assets/images/facilities/canteen-1.jpg" alt="" />
                                <div className="content">
                                    <h1>Canteen</h1>
                                    <p>
                                        To cater the need of the students, the university has a spacious
                                        student's canteen that has the necessary infrastructure.
                                    </p>
                                    <div className="text-center pt-2 pb-2">
                                        <button
                                            type="button"
                                            className="btn btn-facility"
                                            data-bs-toggle="modal"
                                            data-bs-target="#exampleModal2"
                                            style={{ justifyContent: "center" }}
                                        >
                                            Read More
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="modal fade"
                                id="exampleModal2"
                                tabIndex={-1}
                                aria-labelledby="exampleModalLabel"
                                aria-hidden="true"
                            >
                                <div className="modal-dialog modal-lg">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="exampleModalLabel">
                                                Canteen
                                            </h5>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                data-bs-dismiss="modal"
                                                aria-label="Close"
                                            />
                                        </div>
                                        <div className="modal-body">
                                            <div
                                                id="carouselExampleIndicators"
                                                className="carousel slide"
                                                data-bs-ride="carousel"
                                            >
                                                <div className="carousel-inner">
                                                    <div className="carousel-item active">
                                                        <img
                                                            src="assets\images\facilities\canteen-1.jpg"
                                                            className="d-block w-100"
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="carousel-item">
                                                        <img
                                                            src="assets\images\facilities\canteen-2.jpg"
                                                            className="d-block w-100"
                                                            alt=""
                                                        />
                                                    </div>
                                                </div>
                                                <button
                                                    className="carousel-control-prev"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="prev"
                                                >
                                                    <span
                                                        className="carousel-control-prev-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Previous</span>
                                                </button>
                                                <button
                                                    className="carousel-control-next"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="next"
                                                    style={{ color: "black" }}
                                                >
                                                    <span
                                                        className="carousel-control-next-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Next</span>
                                                </button>
                                            </div>
                                            <p className="mt-3">
                                                To cater the need of the students, the university has a
                                                spacious student's canteen that has the necessary
                                                infrastructure.
                                            </p>
                                        </div>
                                        <div className="modal-footer">
                                            <button
                                                type="button"
                                                className="btn btn-secondary"
                                                data-bs-dismiss="modal"
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="box">
                                <img
                                    src="assets/images/facilities/dhan-singh-community.jpg"
                                    alt=""
                                />
                                <div className="content">
                                    <h1>Dhan Singh Kotwal Community Centre</h1>
                                    <p>
                                        The University Campus has a well-maintained Community Center
                                        Established for the purpose of providing a platform for the
                                        community interaction of the University fraternity. The Center has
                                        got sufficient furniture and other facilities in the Center along
                                        with two big halls and two well-furnished bedrooms. Most of the
                                        teachers and employees of the University make of the Community
                                        Center for their family ceremonies.
                                    </p>
                                    <div className="text-center pt-2 pb-2">
                                        <button
                                            type="button"
                                            className="btn btn-facility"
                                            data-bs-toggle="modal"
                                            data-bs-target="#exampleModal3"
                                            style={{ justifyContent: "center" }}
                                        >
                                            Read More
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="modal fade"
                                id="exampleModal3"
                                tabIndex={-1}
                                aria-labelledby="exampleModalLabel"
                                aria-hidden="true"
                            >
                                <div className="modal-dialog modal-lg">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="exampleModalLabel">
                                                Dhan Singh Kotwal Community Centre
                                            </h5>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                data-bs-dismiss="modal"
                                                aria-label="Close"
                                            />
                                        </div>
                                        <div className="modal-body">
                                            <div
                                                id="carouselExampleIndicators"
                                                className="carousel slide"
                                                data-bs-ride="carousel"
                                            >
                                                <div className="carousel-inner">
                                                    <div className="carousel-item active">
                                                        <img
                                                            src="assets/images/facilities/dhan-singh-community.jpg"
                                                            className="d-block w-100"
                                                            alt=""
                                                        />
                                                    </div>
                                                </div>
                                                <button
                                                    className="carousel-control-prev"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="prev"
                                                >
                                                    <span
                                                        className="carousel-control-prev-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Previous</span>
                                                </button>
                                                <button
                                                    className="carousel-control-next"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="next"
                                                    style={{ color: "black" }}
                                                >
                                                    <span
                                                        className="carousel-control-next-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Next</span>
                                                </button>
                                            </div>
                                            <p className="mt-3">
                                                The University Campus has a well-maintained Community Center
                                                Established for the purpose of providing a platform for the
                                                community interaction of the University fraternity. The Center
                                                has got sufficient furniture and other facilities in the
                                                Center along with two big halls and two well-furnished
                                                bedrooms. Most of the teachers and employees of the University
                                                make of the Community Center for their family ceremonies.
                                            </p>
                                        </div>
                                        <div className="modal-footer">
                                            <button
                                                type="button"
                                                className="btn btn-secondary"
                                                data-bs-dismiss="modal"
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="box">
                                <img src="assets/images/facilities/power-house01.jpg" alt="" />
                                <div className="content">
                                    <h1>Electricity and Civil Supplies Department</h1>
                                    <p>
                                        The University has well-equipped electrical department catering to
                                        the needs of the administrative block, teaching departments and
                                        the residences of the staff of the university. We have a rare
                                        distinction of providing 24 x 7 supply and electrical maintenance
                                        facility to all the departments, hostels and offices in the campus
                                        from three power sub-station located in the university. We attend
                                        the complaints, provide generator back-up and take care of
                                        requirements of departments and sections of the university as well
                                        as residential quarters 24 hours/ 365 day a year. The university
                                        has got round-the-clock running water supply throughout the
                                        campus. Even with limited number of permanent staff, we have been
                                        able to provide trouble free services in the university. The
                                        University Engineer Mr. Vikas Tyagi is taking care of the changing
                                        requirements of infrastructure creation, Maintenance, Renovation
                                        and upkeep of the existing facilities.
                                    </p>
                                    <div className="text-center pt-2 pb-2">
                                        <button
                                            type="button"
                                            className="btn btn-facility"
                                            data-bs-toggle="modal"
                                            data-bs-target="#exampleModal4"
                                            style={{ justifyContent: "center" }}
                                        >
                                            Read More
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="modal fade"
                                id="exampleModal4"
                                tabIndex={-1}
                                aria-labelledby="exampleModalLabel"
                                aria-hidden="true"
                            >
                                <div className="modal-dialog modal-lg">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="exampleModalLabel">
                                                Electricity and Civil Supplies Department
                                            </h5>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                data-bs-dismiss="modal"
                                                aria-label="Close"
                                            />
                                        </div>
                                        <div className="modal-body">
                                            <div
                                                id="carouselExampleIndicators"
                                                className="carousel slide"
                                                data-bs-ride="carousel"
                                            >
                                                <div className="carousel-inner">
                                                    <div className="carousel-item active">
                                                        <img
                                                            src="assets/images/facilities/power-house01.jpg"
                                                            className="d-block w-100"
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="carousel-item">
                                                        <img
                                                            src="assets/images/facilities/power-house02.jpg"
                                                            className="d-block w-100"
                                                            alt=""
                                                        />
                                                    </div>
                                                </div>
                                                <button
                                                    className="carousel-control-prev"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="prev"
                                                >
                                                    <span
                                                        className="carousel-control-prev-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Previous</span>
                                                </button>
                                                <button
                                                    className="carousel-control-next"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="next"
                                                    style={{ color: "black" }}
                                                >
                                                    <span
                                                        className="carousel-control-next-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Next</span>
                                                </button>
                                            </div>
                                            <p className="mt-3">
                                                The University Campus has a well-maintained Community Center
                                                Established for the purpose of providing a platform for the
                                                community interaction of the University fraternity. The Center
                                                has got sufficient furniture and other facilities in the
                                                Center along with two big halls and two well-furnished
                                                bedrooms. Most of the teachers and employees of the University
                                                make of the Community Center for their family ceremonies.
                                            </p>
                                        </div>
                                        <div className="modal-footer">
                                            <button
                                                type="button"
                                                className="btn btn-secondary"
                                                data-bs-dismiss="modal"
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="box">
                                <img src="assets/images/facilities/wi-fi-service.jpg" alt="" />
                                <div className="content">
                                    <h1>Fully Wifi Campus</h1>
                                    <p>
                                        Ch. Charan Singh University, Meerut is fully covered with wifi
                                        facility.
                                    </p>
                                    <div className="text-center pt-2 pb-2">
                                        <button
                                            type="button"
                                            className="btn btn-facility"
                                            data-bs-toggle="modal"
                                            data-bs-target="#exampleModal5"
                                            style={{ justifyContent: "center" }}
                                        >
                                            Read More
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="modal fade"
                                id="exampleModal5"
                                tabIndex={-1}
                                aria-labelledby="exampleModalLabel"
                                aria-hidden="true"
                            >
                                <div className="modal-dialog modal-lg">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="exampleModalLabel">
                                                Electricity and Civil Supplies Department
                                            </h5>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                data-bs-dismiss="modal"
                                                aria-label="Close"
                                            />
                                        </div>
                                        <div className="modal-body">
                                            <div
                                                id="carouselExampleIndicators"
                                                className="carousel slide"
                                                data-bs-ride="carousel"
                                            >
                                                <div className="carousel-inner">
                                                    <div className="carousel-item active">
                                                        <img
                                                            src="assets/images/facilities/wi-fi-service.jpg"
                                                            className="d-block w-100"
                                                            alt=""
                                                        />
                                                    </div>
                                                </div>
                                                <button
                                                    className="carousel-control-prev"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="prev"
                                                >
                                                    <span
                                                        className="carousel-control-prev-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Previous</span>
                                                </button>
                                                <button
                                                    className="carousel-control-next"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="next"
                                                    style={{ color: "black" }}
                                                >
                                                    <span
                                                        className="carousel-control-next-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Next</span>
                                                </button>
                                            </div>
                                            <p className="mt-3">
                                                Ch. Charan Singh University, Meerut is fully covered with wifi
                                                facility.
                                            </p>
                                        </div>
                                        <div className="modal-footer">
                                            <button
                                                type="button"
                                                className="btn btn-secondary"
                                                data-bs-dismiss="modal"
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="box">
                                <img src="assets/images/facilities/guest-house02.jpg" alt="" />
                                <div className="content">
                                    <h1>Guest House</h1>
                                    <p>
                                        The University has a well-maintained and fully furnished guest
                                        house in the Campus premises. The Guest House has 17 rooms with
                                        all facilities and four special suits to cater to the heeds of the
                                        visiting faculty members, subject experts, examiners and other
                                        guests. Dr. Vijay Malik Chaubey is the Incharge of the Guest
                                        House.
                                    </p>
                                    <div className="text-center pt-2 pb-2">
                                        <button
                                            type="button"
                                            className="btn btn-facility"
                                            data-bs-toggle="modal"
                                            data-bs-target="#exampleModal6"
                                            style={{ justifyContent: "center" }}
                                        >
                                            Read More
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="modal fade"
                                id="exampleModal6"
                                tabIndex={-1}
                                aria-labelledby="exampleModalLabel"
                                aria-hidden="true"
                            >
                                <div className="modal-dialog modal-lg">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="exampleModalLabel">
                                                Guest House
                                            </h5>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                data-bs-dismiss="modal"
                                                aria-label="Close"
                                            />
                                        </div>
                                        <div className="modal-body">
                                            <div
                                                id="carouselExampleIndicators"
                                                className="carousel slide"
                                                data-bs-ride="carousel"
                                            >
                                                <div className="carousel-inner">
                                                    <div className="carousel-item active">
                                                        <img
                                                            src="assets/images/facilities/guest-house02.jpg"
                                                            className="d-block w-100"
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="carousel-item">
                                                        <img
                                                            src="assets/images/facilities/guest-house04.jpg"
                                                            className="d-block w-100"
                                                            alt=""
                                                        />
                                                    </div>
                                                </div>
                                                <button
                                                    className="carousel-control-prev"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="prev"
                                                >
                                                    <span
                                                        className="carousel-control-prev-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Previous</span>
                                                </button>
                                                <button
                                                    className="carousel-control-next"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="next"
                                                    style={{ color: "black" }}
                                                >
                                                    <span
                                                        className="carousel-control-next-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Next</span>
                                                </button>
                                            </div>
                                            <p className="mt-3">
                                                The University has a well-maintained and fully furnished guest
                                                house in the Campus premises. The Guest House has 17 rooms
                                                with all facilities and four special suits to cater to the
                                                heeds of the visiting faculty members, subject experts,
                                                examiners and other guests. Dr. Vijay Malik Chaubey is the
                                                Incharge of the Guest House.
                                            </p>
                                        </div>
                                        <div className="modal-footer">
                                            <button
                                                type="button"
                                                className="btn btn-secondary"
                                                data-bs-dismiss="modal"
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="box" id="hostels">
                                <img src="assets/images/facilities-4.png" alt="" />
                                <div className="content">
                                    <h1>Hostel</h1>
                                    <p>
                                        The university has Eight fully furnished hostels separately for
                                        boys and girls, equipped with round the clock power back, wi-fi
                                        connection, water heaters, RO water cooler etc. which provide
                                        excellent hostel accommodation for full-time students of the
                                        university departments. Reading rooms and additional sports
                                        facilities like table-tennis rooms, chess and carrom etc are also
                                        available in each hostel. Hostel rooms are available on double
                                        occupancy. Admission to the hostels are made against the available
                                        vacant seats allotted by the Wardens of the hostels according to
                                        University Hostel Rules. The overall charge of student's
                                        discipline and hostel administration vests in the Chief Warden.
                                    </p>
                                    <div className="text-center pt-2 pb-2">
                                        <button
                                            type="button"
                                            className="btn btn-facility"
                                            data-bs-toggle="modal"
                                            data-bs-target="#exampleModal7"
                                            style={{ justifyContent: "center" }}
                                        >
                                            Read More
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="modal fade"
                                id="exampleModal7"
                                tabIndex={-1}
                                aria-labelledby="exampleModalLabel"
                                aria-hidden="true"
                            >
                                <div className="modal-dialog modal-lg">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="exampleModalLabel">
                                                Hostel
                                            </h5>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                data-bs-dismiss="modal"
                                                aria-label="Close"
                                            />
                                        </div>
                                        <div className="modal-body">
                                            <div
                                                id="carouselExampleIndicators"
                                                className="carousel slide"
                                                data-bs-ride="carousel"
                                            >
                                                <div className="carousel-inner">
                                                    <div className="carousel-item active">
                                                        <img
                                                            src="assets/images/facilities/hostel-1.jpg"
                                                            className="d-block w-100"
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="carousel-item">
                                                        <img
                                                            src="assets/images/facilities/hostel-2.jpg"
                                                            className="d-block w-100"
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="carousel-item">
                                                        <img
                                                            src="assets/images/facilities/hostel-3.jpg"
                                                            className="d-block w-100"
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="carousel-item">
                                                        <img
                                                            src="assets/images/facilities/hostel-4.jpg"
                                                            className="d-block w-100"
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="carousel-item">
                                                        <img
                                                            src="assets/images/facilities/hostel-5.jpg"
                                                            className="d-block w-100"
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="carousel-item">
                                                        <img
                                                            src="assets/images/facilities/hostel-6.jpg"
                                                            className="d-block w-100"
                                                            alt=""
                                                        />
                                                    </div>
                                                </div>
                                                <button
                                                    className="carousel-control-prev"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="prev"
                                                >
                                                    <span
                                                        className="carousel-control-prev-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Previous</span>
                                                </button>
                                                <button
                                                    className="carousel-control-next"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="next"
                                                    style={{ color: "black" }}
                                                >
                                                    <span
                                                        className="carousel-control-next-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Next</span>
                                                </button>
                                            </div>
                                            <p className="mt-3">
                                                The university has Eight fully furnished hostels separately
                                                for boys and girls, equipped with round the clock power back,
                                                wi-fi connection, water heaters, RO water cooler etc. which
                                                provide excellent hostel accommodation for full-time students
                                                of the university departments. Reading rooms and additional
                                                sports facilities like table-tennis rooms, chess and carrom
                                                etc are also available in each hostel. Hostel rooms are
                                                available on double occupancy. Admission to the hostels are
                                                made against the available vacant seats allotted by the
                                                Wardens of the hostels according to University Hostel Rules.
                                                The overall charge of student's discipline and hostel
                                                administration vests in the Chief Warden.
                                            </p>
                                            <p>Important Points for Hostel Seekers</p>
                                            <ul>
                                                <li>
                                                    Will have to vacate their rooms after the end of every
                                                    academic session.
                                                </li>
                                                <li>
                                                    Shall not be allowed to stay in the hostels after the
                                                    prescribed time and limit of their study.
                                                </li>
                                                <li>
                                                    Will have to vacate the hostel room on completion of one
                                                    course of study and will have to seek fresh hostel
                                                    accommodation as per the university rule.
                                                </li>
                                                <li>
                                                    Are supposed to conduct themselves extremely well within and
                                                    outside the hostel in disciplined manner.
                                                </li>
                                                <li>
                                                    Are required to pay the hostel and mess fees in time,
                                                    failing which they shall have to vacate the hostel or will
                                                    not be allowed to undertake exams as per rules.
                                                </li>
                                                <li>
                                                    Shall have to strictly follow the rules for occupying hostel
                                                    regarding discipline, conduct and their stay.
                                                </li>
                                                <li>
                                                    Students who had been involved in any type of indiscipline
                                                    cases will not be considered for allotment of hostel rooms.
                                                </li>
                                                <li>
                                                    For more hostel related information, visit the website:
                                                    www.ccsuniversity.ac.in &amp; www.ccsuniversityhostel.com
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="modal-footer">
                                            <button
                                                type="button"
                                                className="btn btn-secondary"
                                                data-bs-dismiss="modal"
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="box">
                                <img src="assets/images/facilities-5.png" alt="" />
                                <div className="content">
                                    <h1>Healthcare Centre</h1>
                                    <p>
                                        The university has a Health Centre (Medical Dispensary) located
                                        near the Guest House of the University. It is open from 8 A.M. to
                                        3 P.M. on all days except Mondays.
                                    </p>
                                    <div className="text-center pt-2 pb-2">
                                        <button
                                            type="button"
                                            className="btn btn-facility"
                                            data-bs-toggle="modal"
                                            data-bs-target="#exampleModal8"
                                            style={{ justifyContent: "center" }}
                                        >
                                            Read More
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="modal fade"
                                id="exampleModal8"
                                tabIndex={-1}
                                aria-labelledby="exampleModalLabel"
                                aria-hidden="true"
                            >
                                <div className="modal-dialog modal-lg">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="exampleModalLabel">
                                                Healthcare centre
                                            </h5>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                data-bs-dismiss="modal"
                                                aria-label="Close"
                                            />
                                        </div>
                                        <div className="modal-body">
                                            <div
                                                id="carouselExampleIndicators"
                                                className="carousel slide"
                                                data-bs-ride="carousel"
                                            >
                                                <div className="carousel-inner">
                                                    <div className="carousel-item active">
                                                        <img
                                                            src="assets/images/facilities/medical-centre-01.jpg"
                                                            className="d-block w-100"
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="carousel-item">
                                                        <img
                                                            src="assets/images/facilities/medical-centre-03.jpg"
                                                            className="d-block w-100"
                                                            alt=""
                                                        />
                                                    </div>
                                                </div>
                                                <button
                                                    className="carousel-control-prev"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="prev"
                                                >
                                                    <span
                                                        className="carousel-control-prev-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Previous</span>
                                                </button>
                                                <button
                                                    className="carousel-control-next"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="next"
                                                    style={{ color: "black" }}
                                                >
                                                    <span
                                                        className="carousel-control-next-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Next</span>
                                                </button>
                                            </div>
                                            <p className="mt-3">
                                                The university has a Health Centre (Medical Dispensary)
                                                located near the Guest House of the University. It is open
                                                from 8 A.M. to 3 P.M. on all days except Mondays, Second
                                                Saturdays and University holidays. A medical officer is
                                                available for consultation. In addition, a pharmacist is also
                                                available during working hours. Plans are afoot to appoint
                                                another pharmacist and a part time lady doctor. The health
                                                centre also has an ambulance to meet emergencies.
                                            </p>
                                        </div>
                                        <div className="modal-footer">
                                            <button
                                                type="button"
                                                className="btn btn-secondary"
                                                data-bs-dismiss="modal"
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="box">
                                <img src="assets/images/facilities-6.png" alt="" />
                                <div className="content">
                                    <h1>Internet Facility</h1>
                                    <p>
                                        The university has created a local area network which is connected
                                        to INTERNET through a leased line. All the departments are
                                        connected through this local area network.
                                    </p>
                                    <div className="text-center pt-2 pb-2">
                                        <button
                                            type="button"
                                            className="btn btn-facility"
                                            data-bs-toggle="modal"
                                            data-bs-target="#exampleModal9"
                                            style={{ justifyContent: "center" }}
                                        >
                                            Read More
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="modal fade"
                                id="exampleModal9"
                                tabIndex={-1}
                                aria-labelledby="exampleModalLabel"
                                aria-hidden="true"
                            >
                                <div className="modal-dialog modal-lg">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="exampleModalLabel">
                                                Internet Facilities
                                            </h5>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                data-bs-dismiss="modal"
                                                aria-label="Close"
                                            />
                                        </div>
                                        <div className="modal-body">
                                            <div
                                                id="carouselExampleIndicators"
                                                className="carousel slide"
                                                data-bs-ride="carousel"
                                            >
                                                <div className="carousel-inner">
                                                    <div className="carousel-item active">
                                                        <img
                                                            src="assets/images/facilities/medical-centre-01.jpg"
                                                            className="d-block w-100"
                                                            alt=""
                                                        />
                                                    </div>
                                                </div>
                                                <button
                                                    className="carousel-control-prev"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="prev"
                                                >
                                                    <span
                                                        className="carousel-control-prev-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Previous</span>
                                                </button>
                                                <button
                                                    className="carousel-control-next"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="next"
                                                    style={{ color: "black" }}
                                                >
                                                    <span
                                                        className="carousel-control-next-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Next</span>
                                                </button>
                                            </div>
                                            <p className="mt-3">
                                                The university has created a local area network which is
                                                connected to INTERNET through a leased line. All the
                                                departments are connected through this local area network. The
                                                computer laboratories of different department are also having
                                                internet browsing facility. All departments of the university
                                                can make use of Internet facilities by paying fee prescribed
                                                from time to time. It is expected to made available different
                                                scientific &amp; academic journals through e-consortium
                                                managed by INFLIBHET.{" "}
                                            </p>
                                        </div>
                                        <div className="modal-footer">
                                            <button
                                                type="button"
                                                className="btn btn-secondary"
                                                data-bs-dismiss="modal"
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="box">
                                <img src="assets/images/facilities-7.png" alt="" />
                                <div className="content">
                                    <h1>Placement Cell</h1>
                                    <p>
                                        The university has established a separate Placement Cell with the
                                        purpose of providing essential information and guidance to the
                                        students of the Campus.
                                    </p>
                                    <div className="text-center pt-2 pb-2">
                                        <button
                                            type="button"
                                            className="btn btn-facility"
                                            data-bs-toggle="modal"
                                            data-bs-target="#exampleModal10"
                                            style={{ justifyContent: "center" }}
                                        >
                                            Read More
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="modal fade"
                                id="exampleModal10"
                                tabIndex={-1}
                                aria-labelledby="exampleModalLabel"
                                aria-hidden="true"
                            >
                                <div className="modal-dialog modal-lg">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="exampleModalLabel">
                                                Placement Cell
                                            </h5>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                data-bs-dismiss="modal"
                                                aria-label="Close"
                                            />
                                        </div>
                                        <div className="modal-body">
                                            <div
                                                id="carouselExampleIndicators"
                                                className="carousel slide"
                                                data-bs-ride="carousel"
                                            >
                                                <div className="carousel-inner">
                                                    <div className="carousel-item active">
                                                        <img
                                                            src="assets/images/facilities/medical-centre-01.jpg"
                                                            className="d-block w-100"
                                                            alt=""
                                                        />
                                                    </div>
                                                </div>
                                                <button
                                                    className="carousel-control-prev"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="prev"
                                                >
                                                    <span
                                                        className="carousel-control-prev-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Previous</span>
                                                </button>
                                                <button
                                                    className="carousel-control-next"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="next"
                                                    style={{ color: "black" }}
                                                >
                                                    <span
                                                        className="carousel-control-next-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Next</span>
                                                </button>
                                            </div>
                                            <p className="mt-3">
                                                The university has established a separate Placement Cell with
                                                the purpose of providing essential information and guidance to
                                                the students of the Campus for their employment opportunity.
                                                The Placement Cell functions as a center for career counseling
                                                and employment bureau. The State Government has also
                                                established an employment bureau in the University Campus that
                                                is situated in the ground floor of the Central Library. Prof.
                                                Rakesh Kumar is the Coordinator of Placement Cell.
                                            </p>
                                        </div>
                                        <div className="modal-footer">
                                            <button
                                                type="button"
                                                className="btn btn-secondary"
                                                data-bs-dismiss="modal"
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="box">
                                <img src="assets/images/facilities/post-office.jpg" alt="" />
                                <div className="content">
                                    <h1>Post office</h1>
                                    <p>
                                        Post office facility is available inside C.C.S. University Campus
                                        for all students, staff and visitors to access all kinds of post
                                        office services in Government working days and hours.
                                    </p>
                                    <div className="text-center pt-2 pb-2">
                                        <button
                                            type="button"
                                            className="btn btn-facility"
                                            data-bs-toggle="modal"
                                            data-bs-target="#exampleModal12"
                                            style={{ justifyContent: "center" }}
                                        >
                                            Read More
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="modal fade"
                                id="exampleModal12"
                                tabIndex={-1}
                                aria-labelledby="exampleModalLabel"
                                aria-hidden="true"
                            >
                                <div className="modal-dialog modal-lg">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="exampleModalLabel">
                                                Post office
                                            </h5>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                data-bs-dismiss="modal"
                                                aria-label="Close"
                                            />
                                        </div>
                                        <div className="modal-body">
                                            <div
                                                id="carouselExampleIndicators"
                                                className="carousel slide"
                                                data-bs-ride="carousel"
                                            >
                                                <div className="carousel-inner">
                                                    <div className="carousel-item active">
                                                        <img
                                                            src="assets/images/facilities/post-office.jpg"
                                                            className="d-block w-100"
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="carousel-item">
                                                        <img
                                                            src="assets/images/facilities/post-office02.jpg"
                                                            className="d-block w-100"
                                                            alt=""
                                                        />
                                                    </div>
                                                </div>
                                                <button
                                                    className="carousel-control-prev"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="prev"
                                                >
                                                    <span
                                                        className="carousel-control-prev-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Previous</span>
                                                </button>
                                                <button
                                                    className="carousel-control-next"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="next"
                                                    style={{ color: "black" }}
                                                >
                                                    <span
                                                        className="carousel-control-next-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Next</span>
                                                </button>
                                            </div>
                                            <p className="mt-3">
                                                Post office facility is available inside C.C.S. University
                                                Campus for all students, staff and visitors to access all
                                                kinds of post office services in Government working days and
                                                hours.
                                            </p>
                                        </div>
                                        <div className="modal-footer">
                                            <button
                                                type="button"
                                                className="btn btn-secondary"
                                                data-bs-dismiss="modal"
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="box">
                                <img src="assets/images/facilities/power-house01.jpg" alt="" />
                                <div className="content">
                                    <h1>Powerhouse</h1>
                                    <p>
                                        The university provides the power back-up facility for 24x7 hours
                                        with Solar Power (Green Energy) to the institute including all the
                                        Departments, Hostels, Library, Workshops, Laboratories etc.
                                    </p>
                                    <div className="text-center pt-2 pb-2">
                                        <button
                                            type="button"
                                            className="btn btn-facility"
                                            data-bs-toggle="modal"
                                            data-bs-target="#exampleModal13"
                                            style={{ justifyContent: "center" }}
                                        >
                                            Read More
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="modal fade"
                                id="exampleModal13"
                                tabIndex={-1}
                                aria-labelledby="exampleModalLabel"
                                aria-hidden="true"
                            >
                                <div className="modal-dialog modal-lg">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="exampleModalLabel">
                                                Powerhouse
                                            </h5>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                data-bs-dismiss="modal"
                                                aria-label="Close"
                                            />
                                        </div>
                                        <div className="modal-body">
                                            <div
                                                id="carouselExampleIndicators"
                                                className="carousel slide"
                                                data-bs-ride="carousel"
                                            >
                                                <div className="carousel-inner">
                                                    <div className="carousel-item active">
                                                        <img
                                                            src="assets/images/facilities/power-house01.jpg"
                                                            className="d-block w-100"
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="carousel-item">
                                                        <img
                                                            src="assets/images/facilities/power-house02.jpg"
                                                            className="d-block w-100"
                                                            alt=""
                                                        />
                                                    </div>
                                                </div>
                                                <button
                                                    className="carousel-control-prev"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="prev"
                                                >
                                                    <span
                                                        className="carousel-control-prev-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Previous</span>
                                                </button>
                                                <button
                                                    className="carousel-control-next"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="next"
                                                    style={{ color: "black" }}
                                                >
                                                    <span
                                                        className="carousel-control-next-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Next</span>
                                                </button>
                                            </div>
                                            <p className="mt-3">
                                                Post office facility is available inside C.C.S. University
                                                Campus for all students, staff and visitors to access all
                                                kinds of post office services in Government working days and
                                                hours.
                                            </p>
                                        </div>
                                        <div className="modal-footer">
                                            <button
                                                type="button"
                                                className="btn btn-secondary"
                                                data-bs-dismiss="modal"
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="box">
                                <img src="assets/images/facilities/railway-01.jpg" alt="" />
                                <div className="content">
                                    <h1>Railway Reservation</h1>
                                    <p>
                                        The Indian Railway Office is situated at University Campus near to
                                        C.C.S. University Allahabad bank to facilitate students for
                                        reserve seat.
                                    </p>
                                    <div className="text-center pt-2 pb-2">
                                        <button
                                            type="button"
                                            className="btn btn-facility"
                                            data-bs-toggle="modal"
                                            data-bs-target="#exampleModal14"
                                            style={{ justifyContent: "center" }}
                                        >
                                            Read More
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="modal fade"
                                id="exampleModal14"
                                tabIndex={-1}
                                aria-labelledby="exampleModalLabel"
                                aria-hidden="true"
                            >
                                <div className="modal-dialog modal-lg">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="exampleModalLabel">
                                                Railway Reservation
                                            </h5>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                data-bs-dismiss="modal"
                                                aria-label="Close"
                                            />
                                        </div>
                                        <div className="modal-body">
                                            <div
                                                id="carouselExampleIndicators"
                                                className="carousel slide"
                                                data-bs-ride="carousel"
                                            >
                                                <div className="carousel-inner">
                                                    <div className="carousel-item active">
                                                        <img
                                                            src="assets/images/facilities/railway-01.jpg"
                                                            className="d-block w-100"
                                                            alt=""
                                                        />
                                                    </div>
                                                </div>
                                                <button
                                                    className="carousel-control-prev"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="prev"
                                                >
                                                    <span
                                                        className="carousel-control-prev-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Previous</span>
                                                </button>
                                                <button
                                                    className="carousel-control-next"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="next"
                                                    style={{ color: "black" }}
                                                >
                                                    <span
                                                        className="carousel-control-next-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Next</span>
                                                </button>
                                            </div>
                                            <p className="mt-3">
                                                The Indian Railway Office is situated at University Campus
                                                near to C.C.S. University Allahabad bank to facilitate
                                                students for reserve seat.
                                            </p>
                                            <p>
                                                The Indian railways have extended the facility of railway
                                                concession of 50% railway fare to all categories of the
                                                students of the institute by submission of request form
                                                through the Administrative Officer of the Institute and to the
                                                office of the Dean Students Welfare.
                                            </p>
                                            <p>
                                                There is a rail reservation counter available in the
                                                University Campus.
                                            </p>
                                            <p>Timings are 08:00 AM to 02:00 PM (Sunday Off)</p>
                                        </div>
                                        <div className="modal-footer">
                                            <button
                                                type="button"
                                                className="btn btn-secondary"
                                                data-bs-dismiss="modal"
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="box">
                                <img src="assets/images/facilities-6.png" alt="" />
                                <div className="content">
                                    <h1>ST &amp; SC Cell</h1>
                                    <p>
                                        The university campus has got a substantially large numbers of
                                        students belonging to Scheduled Castes/Scheduled Tribes Category.
                                        Therefore, we have established an ST &amp; SC Cell/Scheduled
                                        Tribes Cell to guide the ST &amp; SC Cell/Scheduled Tribes
                                        Students for their scholarships, fellowships, govt. schemes and
                                        the provisions for their benefit. Prof. Dinesh Kumar is the
                                        Coordinator of the Scheduled Castes/Scheduled Tribes Cell.
                                    </p>
                                    <div className="text-center pt-2 pb-2">
                                        <button
                                            type="button"
                                            className="btn btn-facility"
                                            data-bs-toggle="modal"
                                            data-bs-target="#exampleModal15"
                                            style={{ justifyContent: "center" }}
                                        >
                                            Read More
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="modal fade"
                                id="exampleModal15"
                                tabIndex={-1}
                                aria-labelledby="exampleModalLabel"
                                aria-hidden="true"
                            >
                                <div className="modal-dialog modal-lg">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="exampleModalLabel">
                                                ST &amp; SC Cell
                                            </h5>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                data-bs-dismiss="modal"
                                                aria-label="Close"
                                            />
                                        </div>
                                        <div className="modal-body">
                                            <div
                                                id="carouselExampleIndicators"
                                                className="carousel slide"
                                                data-bs-ride="carousel"
                                            >
                                                <div className="carousel-inner">
                                                    <div className="carousel-item active">
                                                        <img
                                                            src="assets/images/facilities/power-house01.jpg"
                                                            className="d-block w-100"
                                                            alt=""
                                                        />
                                                    </div>
                                                </div>
                                                <button
                                                    className="carousel-control-prev"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="prev"
                                                >
                                                    <span
                                                        className="carousel-control-prev-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Previous</span>
                                                </button>
                                                <button
                                                    className="carousel-control-next"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="next"
                                                    style={{ color: "black" }}
                                                >
                                                    <span
                                                        className="carousel-control-next-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Next</span>
                                                </button>
                                            </div>
                                            <p className="mt-3">
                                                The university campus has got a substantially large numbers of
                                                students belonging to Scheduled Castes/Scheduled Tribes
                                                Category. Therefore, we have established an ST &amp; SC
                                                Cell/Scheduled Tribes Cell to guide the Scheduled
                                                Castes/Scheduled Tribes Students for their scholarships,
                                                fellowships, govt. schemes and the provisions for their
                                                benefit. Prof. Dinesh Kumar is the Coordinator of the ST &amp;
                                                SC Cell/Scheduled Tribes Cell.
                                            </p>
                                        </div>
                                        <div className="modal-footer">
                                            <button
                                                type="button"
                                                className="btn btn-secondary"
                                                data-bs-dismiss="modal"
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="box">
                                <img src="assets/images/facilities/eqal-opp.jpg" alt="" />
                                <div className="content">
                                    <h1>Equal opportunity centre</h1>
                                    <p> </p>
                                    <div className="text-center pt-2 pb-2">
                                        <button
                                            type="button"
                                            className="btn btn-facility"
                                            data-bs-toggle="modal"
                                            data-bs-target="#exampleModal155"
                                            style={{ justifyContent: "center" }}
                                        >
                                            Read More
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="modal fade"
                                id="exampleModal155"
                                tabIndex={-1}
                                aria-labelledby="exampleModalLabel"
                                aria-hidden="true"
                            >
                                <div className="modal-dialog modal-lg">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="exampleModalLabel">
                                                Equal opportunity centre
                                            </h5>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                data-bs-dismiss="modal"
                                                aria-label="Close"
                                            />
                                        </div>
                                        <div className="modal-body">
                                            <div
                                                id="carouselExampleIndicators"
                                                className="carousel slide"
                                                data-bs-ride="carousel"
                                            >
                                                <div className="carousel-inner">
                                                    <div className="carousel-item active">
                                                        <img
                                                            src="assets/images/facilities/eqal-opp.jpg"
                                                            className="d-block w-100"
                                                            alt=""
                                                        />
                                                    </div>
                                                </div>
                                                <button
                                                    className="carousel-control-prev"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="prev"
                                                >
                                                    <span
                                                        className="carousel-control-prev-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Previous</span>
                                                </button>
                                                <button
                                                    className="carousel-control-next"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="next"
                                                    style={{ color: "black" }}
                                                >
                                                    <span
                                                        className="carousel-control-next-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Next</span>
                                                </button>
                                            </div>
                                            <p className="mt-3"> </p>
                                        </div>
                                        <div className="modal-footer">
                                            <button
                                                type="button"
                                                className="btn btn-secondary"
                                                data-bs-dismiss="modal"
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="box">
                                <img src="assets/images/facilities/sports-1.jpg" alt="" />
                                <div className="content">
                                    <h1>Sports &amp; Games</h1>
                                    <p>
                                        The university campus has excellent indoor and outdoor sports
                                        facilities for almost all major games, which are available to the
                                        students of university campus. Besides this, some indoor and
                                        outdoor games facilities i.e. basket ball, volley ball, table
                                        tennis, chess, carom, cricket, badminton, football and wrestling
                                        etc. are also available to our students within the institute
                                        premises.
                                    </p>
                                    <div className="text-center pt-2 pb-2">
                                        <button
                                            type="button"
                                            className="btn btn-facility"
                                            data-bs-toggle="modal"
                                            data-bs-target="#exampleModal16"
                                            style={{ justifyContent: "center" }}
                                        >
                                            Read More
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="modal fade"
                                id="exampleModal16"
                                tabIndex={-1}
                                aria-labelledby="exampleModalLabel"
                                aria-hidden="true"
                            >
                                <div className="modal-dialog modal-lg">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="exampleModalLabel16">
                                                Sports &amp; Games
                                            </h5>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                data-bs-dismiss="modal"
                                                aria-label="Close"
                                            />
                                        </div>
                                        <div className="modal-body">
                                            <div
                                                id="carouselExampleIndicators"
                                                className="carousel slide"
                                                data-bs-ride="carousel"
                                            >
                                                <div className="carousel-inner">
                                                    <div className="carousel-item active">
                                                        <img
                                                            src="assets/images/facilities/sports-1.jpg"
                                                            className="d-block w-100"
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="carousel-item">
                                                        <img
                                                            src="assets/images/facilities/sports-2.jpg"
                                                            className="d-block w-100"
                                                            alt=""
                                                        />
                                                    </div>
                                                </div>
                                                <button
                                                    className="carousel-control-prev"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="prev"
                                                >
                                                    <span
                                                        className="carousel-control-prev-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Previous</span>
                                                </button>
                                                <button
                                                    className="carousel-control-next"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="next"
                                                    style={{ color: "black" }}
                                                >
                                                    <span
                                                        className="carousel-control-next-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Next</span>
                                                </button>
                                            </div>
                                            <p className="mt-3">
                                                The university campus has excellent indoor and outdoor sports
                                                facilities for almost all major games, which are available to
                                                the students of university campus. Besides this, some indoor
                                                and outdoor games facilities i.e. basket ball, volley ball,
                                                table tennis, chess, carom, cricket, badminton, football and
                                                wrestling etc. are also available to our students within the
                                                institute premises.
                                            </p>
                                        </div>
                                        <div className="modal-footer">
                                            <button
                                                type="button"
                                                className="btn btn-secondary"
                                                data-bs-dismiss="modal"
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="box">
                                <img src="assets/images/facilities/computer-center-01.jpg" alt="" />
                                <div className="content">
                                    <h1>University Computer Centre</h1>
                                    <p>
                                        Ever since its establishment in the year 1990, as a central
                                        facility, the Computer Centre is extending all need-based
                                        computational facilities to the students, research scholars and
                                        faculty members of the university campus departments. It offers
                                        Computer Science courses to the students of various departments
                                        established under the auspicies of the University Grants
                                        Commission. It has also started rendering services to the
                                        university administration like university pre-examination data
                                        processing, declaration of results, printing of mark-sheets,
                                        preparation of salary statements, prepration of provident fund
                                        statements, etc.
                                    </p>
                                    <div className="text-center pt-2 pb-2">
                                        <button
                                            type="button"
                                            className="btn btn-facility"
                                            data-bs-toggle="modal"
                                            data-bs-target="#exampleModal17"
                                            style={{ justifyContent: "center" }}
                                        >
                                            Read More
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="modal fade"
                                id="exampleModal17"
                                tabIndex={-1}
                                aria-labelledby="exampleModalLabel"
                                aria-hidden="true"
                            >
                                <div className="modal-dialog modal-lg">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="exampleModalLabel">
                                                University Computer Centre
                                            </h5>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                data-bs-dismiss="modal"
                                                aria-label="Close"
                                            />
                                        </div>
                                        <div className="modal-body">
                                            <div
                                                id="carouselExampleIndicators"
                                                className="carousel slide"
                                                data-bs-ride="carousel"
                                            >
                                                <div className="carousel-inner">
                                                    <div className="carousel-item active">
                                                        <img
                                                            src="assets/images/facilities/computer-center-01.jpg"
                                                            className="d-block w-100"
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="carousel-item">
                                                        <img
                                                            src="assets/images/facilities/computer-center-02.jpg"
                                                            className="d-block w-100"
                                                            alt=""
                                                        />
                                                    </div>
                                                </div>
                                                <button
                                                    className="carousel-control-prev"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="prev"
                                                >
                                                    <span
                                                        className="carousel-control-prev-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Previous</span>
                                                </button>
                                                <button
                                                    className="carousel-control-next"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="next"
                                                    style={{ color: "black" }}
                                                >
                                                    <span
                                                        className="carousel-control-next-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Next</span>
                                                </button>
                                            </div>
                                            <p className="mt-3">
                                                Ever since its establishment in the year 1990, as a central
                                                facility, the Computer Centre is extending all need-based
                                                computational facilities to the students, research scholars
                                                and faculty members of the university campus departments. It
                                                offers Computer Science courses to the students of various
                                                departments established under the auspicies of the University
                                                Grants Commission. It has also started rendering services to
                                                the university administration like university pre-examination
                                                data processing, declaration of results, printing of
                                                mark-sheets, preparation of salary statements, prepration of
                                                provident fund statements, etc.
                                            </p>
                                            <p>
                                                Presently the centre has two servers, 35 Pentium IV, 37
                                                Pentium III and one 386 computer systems. It has three high
                                                speed line printers (600 lpm and 1500 lpm). Proposals are in
                                                the pipe-line to have additional 30 Pentium III nodes on
                                                net-working. Since the present Vice-Chancelor is taking keen
                                                interest to establish this centre as a nodal centre to meet
                                                all requirements of the university administration, students
                                                and faculty members of the campus departments, the centre is
                                                planning to spread awareness regarding the uses and
                                                applications of computers by providing training to all
                                                concerned.
                                            </p>
                                        </div>
                                        <div className="modal-footer">
                                            <button
                                                type="button"
                                                className="btn btn-secondary"
                                                data-bs-dismiss="modal"
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="box">
                                <img src="assets/images/facilities-5.png" alt="" />
                                <div className="content">
                                    <h1>Women Cell</h1>
                                    <p>
                                        The University has a full-fledged Women Cell in the Campus that
                                        has been performing the role of providing help and guidance to the
                                        female students of the Campus besides listening to their
                                        complaints. Prof. Jaimala is the Coordinator of the Women’s Cell.
                                    </p>
                                    <div className="text-center pt-2 pb-2">
                                        <button
                                            type="button"
                                            className="btn btn-facility"
                                            data-bs-toggle="modal"
                                            data-bs-target="#exampleModal18"
                                            style={{ justifyContent: "center" }}
                                        >
                                            Read More
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="modal fade"
                                id="exampleModal18"
                                tabIndex={-1}
                                aria-labelledby="exampleModalLabel"
                                aria-hidden="true"
                            >
                                <div className="modal-dialog modal-lg">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="exampleModalLabel">
                                                Women Cell
                                            </h5>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                data-bs-dismiss="modal"
                                                aria-label="Close"
                                            />
                                        </div>
                                        <div className="modal-body">
                                            <div
                                                id="carouselExampleIndicators"
                                                className="carousel slide"
                                                data-bs-ride="carousel"
                                            >
                                                <div className="carousel-inner">
                                                    <div className="carousel-item active">
                                                        <img
                                                            src="assets/images/facilities/power-house01.jpg"
                                                            className="d-block w-100"
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="carousel-item">
                                                        <img
                                                            src="assets/images/facilities/power-house02.jpg"
                                                            className="d-block w-100"
                                                            alt=""
                                                        />
                                                    </div>
                                                </div>
                                                <button
                                                    className="carousel-control-prev"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="prev"
                                                >
                                                    <span
                                                        className="carousel-control-prev-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Previous</span>
                                                </button>
                                                <button
                                                    className="carousel-control-next"
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide="next"
                                                    style={{ color: "black" }}
                                                >
                                                    <span
                                                        className="carousel-control-next-icon"
                                                        aria-hidden="true"
                                                        style={{ color: "black" }}
                                                    />
                                                    <span className="visually-hidden">Next</span>
                                                </button>
                                            </div>
                                            <p className="mt-3">
                                                The University has a full-fledged Women Cell in the Campus
                                                that has been performing the role of providing help and
                                                guidance to the female students of the Campus besides
                                                listening to their complaints. Prof. Jaimala is the
                                                Coordinator of the Women’s Cell.
                                            </p>
                                        </div>
                                        <div className="modal-footer">
                                            <button
                                                type="button"
                                                className="btn btn-secondary"
                                                data-bs-dismiss="modal"
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Main;